var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoalLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C4.03448 18 0 13.9655 0 9C0 4.03448 4.03448 0 9 0C13.9655 0 18 4.03448 18 9C18 13.9655 13.9655 18 9 18Z",
    fill: "#318713"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4581 9.93135C10.5823 9.62101 10.6443 9.31066 10.6443 9.00032C10.6443 8.00721 9.83743 7.26238 8.81329 7.16928C7.44778 7.04514 6.54778 7.6348 6.17536 7.91411C6.02019 8.03825 5.95812 8.28652 6.08226 8.4417C6.2064 8.59687 6.45467 8.6279 6.60985 8.5348C6.95123 8.31756 7.29261 8.25549 7.54088 8.5348C7.78916 8.78307 7.69605 9.15549 7.54088 9.4348L6.02019 12.4451C5.89605 12.7555 5.83398 13.0658 5.83398 13.3762C5.83398 14.3693 6.64088 15.1141 7.66502 15.2072C9.03054 15.3314 9.93054 14.7417 10.303 14.4624C10.4581 14.3382 10.5202 14.09 10.3961 13.9348C10.2719 13.7796 10.0236 13.7486 9.86847 13.8417C9.52709 14.0589 9.18571 14.121 8.93743 13.8417C8.68916 13.5934 8.78226 13.221 8.93743 12.9417L10.4581 9.93135Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.119 6.20676C11.0617 6.20676 11.8259 5.44256 11.8259 4.49987C11.8259 3.55717 11.0617 2.79297 10.119 2.79297C9.17631 2.79297 8.41211 3.55717 8.41211 4.49987C8.41211 5.44256 9.17631 6.20676 10.119 6.20676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoalLine);
export default __webpack_public_path__ + "static/media/icon-goal-line.69a8da3c5789352f98e9908963b10b50.svg";
export { ForwardRef as ReactComponent };